import * as React from 'react';
import { view, prop } from '@vscode/observables-react';
import type { ExplorerModel } from './ExplorerModel.js';

const searchContainerStyle: React.CSSProperties = {
	padding: '4px 8px',
	borderBottom: '1px solid var(--component-explorer-panel-border)',
};

const searchInputStyle: React.CSSProperties = {
	width: '100%',
	height: '24px',
	padding: '0 22px 0 6px',
	fontSize: '12px',
	color: 'var(--component-explorer-input-foreground)',
	backgroundColor: 'var(--component-explorer-input-background)',
	border: '1px solid var(--component-explorer-input-border, transparent)',
	borderRadius: '2px',
	outline: 'none',
	boxSizing: 'border-box',
};

const searchWrapperStyle: React.CSSProperties = {
	position: 'relative',
};

const clearButtonStyle: React.CSSProperties = {
	position: 'absolute',
	right: '2px',
	top: '50%',
	transform: 'translateY(-50%)',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	width: '18px',
	height: '18px',
	border: 'none',
	background: 'transparent',
	color: 'var(--component-explorer-input-foreground)',
	cursor: 'pointer',
	borderRadius: '2px',
	fontSize: '14px',
	opacity: 0.7,
};

export const SearchInput = view(
	{
		model: prop.const<ExplorerModel>(),
	},
	(reader, props) => {
		const query = props.model.searchQuery.read(reader);
		return (
			<div style={searchContainerStyle}>
				<div style={searchWrapperStyle}>
					<input
						type="text"
						placeholder="Filter (name or label)"
						style={searchInputStyle}
						value={query ?? ''}
						onChange={(e) => props.model.searchQuery.set(e.target.value || undefined, undefined)}
						onFocus={(e) => (e.target.style.borderColor = 'var(--component-explorer-focusBorder)')}
						onBlur={(e) => (e.target.style.borderColor = 'var(--component-explorer-input-border, transparent)')}
					/>
					{query && (
						<button
							style={clearButtonStyle}
							onClick={() => props.model.searchQuery.set(undefined, undefined)}
							title="Clear filter"
						>
							×
						</button>
					)}
				</div>
			</div>
		);
	}
);
